export default "__VITE_ASSET__Dxoisg8Z__"